import React, { ReactNode } from 'react';
import { ContentfulProvider } from 'react-contentful';
import client from './client';

const ClientProvider = (props: { children: ReactNode }): JSX.Element => {
    return <ContentfulProvider client={client}>{props.children}</ContentfulProvider>;
};

export default ClientProvider;
